import React from 'react';
import Navbars from './Navbars';
import Heros from './Heros';
import Features from './Features';
import {Footer} from "../../shared";


function DroneshalaPages() {
  return (
    <div className="min-h-screen bg-white">
      <Navbars />
      <div className="pt-16">
        <Heros />
        <Features />
      </div>
      <Footer />
    </div>
    
  );
}

export default DroneshalaPages;